/** True when both lists contain the same ids. Each list's ids are unique. */
export const haveSameIds = (
  left: readonly string[],
  right: readonly string[]
) => left.length === right.length && left.every(id => right.includes(id));

export const insertIf = <T>(condition: unknown, item: T): T[] =>
  condition ? [item] : [];
